import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs'; // Para Angular 14+ (ou use toPromise em versões antigas)

// Interface para garantir tipagem forte (copie a estrutura do seu environment)
export interface AppConfig {
  production: boolean,
  staging: boolean,
  hashEmailSmsAuthorization: string,
  internalToken: string,
  googleClientId: string,
  urlApiBase: string,
  urlGPABase: string,
  overrides?: { [key: string]: string };
}

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  private config: AppConfig | null = null;

  constructor(private http: HttpClient) { }

  loadConfig() {
    // O arquivo está em assets/config.json
    return firstValueFrom(this.http.get<AppConfig>('/assets/config-env/config.json'))
      .then(config => {
        this.config = config;
      })
      .catch(err => {
        console.error('Erro ao carregar configurações', err);
      });
  }

  // Método para pegar as configurações
  get settings(): AppConfig {
    if (!this.config) {
      throw new Error('Configuração não carregada!');
    }
    return this.config;
  }
}